import { memo } from 'react';
import styled from 'styled-components';

// Components
import { Modal } from 'carbon-components-react';

const MyModal = ({
  modalSubheading,
  children,
  passiveModal = true,
  secondaryButtonText = "Cancel",
  primaryButtonText = "Submit",
  ...remainingProps
}) => {
  return (
    <Modal
      passiveModal={passiveModal}
      secondaryButtonText={secondaryButtonText}
      primaryButtonText={primaryButtonText}
      {...remainingProps}
    >
      {modalSubheading && <Subheading>{modalSubheading}</Subheading>}
      {children}
    </Modal>
  );
};

export default memo(MyModal);

const Subheading = styled.div`
  position: relative;
  top: -12px;
  z-index: 100;
  font-size: .75rem;
  font-weight: 400;
  letter-spacing: .32px;
  color: #525252;
`